import { hasValue } from '@famly/stat_ts-utils_has-value';
import { isErrorNamed } from './is-error-named';
import { readServerErrorObject } from './read-server-error-object';
const readBodyGraphQLErrors = (error) => {
    var _a;
    const errors = (_a = readServerErrorObject(error)) === null || _a === void 0 ? void 0 : _a.errors;
    return Array.isArray(errors) ? errors : undefined;
};
/**
 * Reads an `ErrorLink` handler's options the same way on Apollo 3 and 4, including the GraphQL
 * errors listed in a failed request's body, which Apollo 4 no longer extracts.
 */
export const readErrorHandlerOptions = (options) => {
    const { graphQLErrors, networkError, response, error, result } = options;
    // Apollo 3 passes the GraphQL errors and the network error separately.
    if (hasValue(graphQLErrors) || hasValue(networkError)) {
        return { graphQLErrors, networkError: networkError !== null && networkError !== void 0 ? networkError : undefined, response };
    }
    if (isErrorNamed(error, 'CombinedGraphQLErrors')) {
        return {
            graphQLErrors: error.errors,
            networkError: undefined,
            response: result,
        };
    }
    // Protocol errors only come from multipart subscriptions, which the app does not use.
    if (!hasValue(error) || isErrorNamed(error, 'CombinedProtocolErrors')) {
        return { graphQLErrors: undefined, networkError: undefined, response: result !== null && result !== void 0 ? result : response };
    }
    return { graphQLErrors: readBodyGraphQLErrors(error), networkError: error, response: result };
};
